import { API_BASE_URL } from "../props";
import { useDelete, useGet, usePost, usePut } from "../common/fetchServices";

const getModuleGroupUrl = ({ id }) => `${API_BASE_URL}/module-groups/${id}`;

export const useModuleGroups = () => {
  const url = `${API_BASE_URL}/module-groups?limit=all`;
  return useGet(["module-groups-all"], url);
};

export const useModuleGroup = id => {
  const url = `${API_BASE_URL}/module-groups/${id}`;
  return useGet(["module-group", { id }], url);
};

export const useModuleGroupCreate = () => {
  return usePost(() => `${API_BASE_URL}/module-groups`, {
    queriesToInvalidate: [["module-groups-all"]],
  });
};

// PUT to update module group, i.e. add/remove module from module group
export const useModuleGroupUpdate = () => {
  return usePut(getModuleGroupUrl, {
    queriesToInvalidate: [["module-group", ["id"]]],
  });
};

export const useModuleGroupDelete = id => {
  return useDelete(getModuleGroupUrl, {
    queriesToInvalidate: [["module-group", ["id"]]],
  });
};

export const useModules = () => {
  const url = `${API_BASE_URL}/admin/modules?limit=all`;
  return useGet(["modules", { url }], url);
};
